import _ from "lodash";
import request, { formatServerErrors } from "../config";

const initialState = {
  loading: true,
  email_accounts: [],
  email_account: { data: [] },
  domains: {}
};

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case "GET_EMAIL_ACCOUNTS":
      return {
        ...state,
        loading: true
      };

    case "GET_EMAIL_ACCOUNTS_SUCCESS":
      return {
        ...state,
        loading: false,
        email_accounts: action.data.resources,
        paginationInfo: action.data.pagination
      };

    case "GET_EMAIL_ACCOUNTS_FAIL":
      return {
        ...state,
        loading: false,
        email_accounts: []
      };

    case "ADD_EMAIL_ACCOUNT":
      return {
        ...state,
        loading: true
      };

    case "ADD_EMAIL_ACCOUNT_FAIL":
      return {
        ...state,
        loading: false,
        errors: formatServerErrors(action.errors.errors)
      };

    case "ADD_EMAIL_ACCOUNT_SUCCESS":
      return {
        ...state,
        loading: false,
        errors: undefined
      };

    default:
      return state;
  }
}
